import "./App.css";
import { lazy, Suspense } from "react";
import { BrowserRouter as Router, Switch, Route, Redirect } from "react-router-dom";
import { useEffect } from "react";
import $ from "jquery";
import posthog from "posthog-js";

import LandingPage from "./pages/landingPage/LandingPage";
import Free50Signup from "./pages/Free50Signup";
import FreeResources from "./pages/FreeResources";

const LearnQuranicArabic = lazy(() => import("./pages/seo/LearnQuranicArabic"));
const UnderstandQuranEasily = lazy(() => import("./pages/seo/UnderstandQuranEasily"));
const QuranHabitBuilder = lazy(() => import("./pages/seo/QuranHabitBuilder"));
const QuranStoriesForLearning = lazy(() => import("./pages/seo/QuranStoriesForLearning"));
const BestQuranLearningApp = lazy(() => import("./pages/seo/BestQuranLearningApp"));
const BlogList = lazy(() => import("./pages/blog/BlogList"));
const CommonQuranicWords = lazy(() => import("./pages/blog/articles/CommonQuranicWords"));
const UnderstandQuranWithoutArabic = lazy(() => import("./pages/blog/articles/UnderstandQuranWithoutArabic"));
const DailyQuranHabit = lazy(() => import("./pages/blog/articles/DailyQuranHabit"));
const BeginnerGuideQuranicArabic = lazy(() => import("./pages/blog/articles/BeginnerGuideQuranicArabic"));
const LearnReadQuranBeginners = lazy(() => import("./pages/blog/articles/LearnReadQuranBeginners"));
const MemorizeQuranFasterTips = lazy(() => import("./pages/blog/articles/MemorizeQuranFasterTips"));
const LearnArabicForQuran = lazy(() => import("./pages/blog/articles/LearnArabicForQuran"));
const MostCommonWordsQuran = lazy(() => import("./pages/blog/articles/MostCommonWordsQuran"));
const BestQuranAppsLearning = lazy(() => import("./pages/blog/articles/BestQuranAppsLearning"));
const QuranForBeginnersFirstSteps = lazy(() => import("./pages/blog/articles/QuranForBeginnersFirstSteps"));
const HowLongLearnQuranicArabic = lazy(() => import("./pages/blog/articles/HowLongLearnQuranicArabic"));
const WordByWordQuranUnderstand = lazy(() => import("./pages/blog/articles/WordByWordQuranUnderstand"));
const CompleteQuranRamadanScheduleTips = lazy(() => import("./pages/blog/articles/CompleteQuranRamadanScheduleTips"));
const LearnQuranDuringRamadan = lazy(() => import("./pages/blog/articles/LearnQuranDuringRamadan"));
const HowMuchQuranReadRamadan = lazy(() => import("./pages/blog/articles/HowMuchQuranReadRamadan"));
const QuranHabitAfterRamadan = lazy(() => import("./pages/blog/articles/QuranHabitAfterRamadan"));
const BestQuranAppRamadan = lazy(() => import("./pages/blog/articles/BestQuranAppRamadan"));
const PrepareRamadanQuranHabit = lazy(() => import("./pages/blog/articles/PrepareRamadanQuranHabit"));
const BestWayMemorizeQuran = lazy(() => import("./pages/blog/articles/BestWayMemorizeQuran"));
const QuranMemorizationTechniques = lazy(() => import("./pages/blog/articles/QuranMemorizationTechniques"));
const HowToBecomeHafiz = lazy(() => import("./pages/blog/articles/HowToBecomeHafiz"));
const BestQuranMemorizationApp = lazy(() => import("./pages/blog/articles/BestQuranMemorizationApp"));
const SpacedRepetitionQuranMemorization = lazy(() => import("./pages/blog/articles/SpacedRepetitionQuranMemorization"));
const MemorizeQuranBeginners = lazy(() => import("./pages/blog/articles/MemorizeQuranBeginners"));
const HowLongMemorizeQuran = lazy(() => import("./pages/blog/articles/HowLongMemorizeQuran"));

function PageFallback() {
  return (
    <div style={{ minHeight: "40vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
      <p style={{ color: "#666" }}>Loading…</p>
    </div>
  );
}

function App() {
  useEffect(() => {
    // Initialize PostHog
    posthog.init('phc_sLjmijlAiR0mj88o9JLgz4SgpJhOBYLXPZJBxhFSMSw', {
      api_host: 'https://us.posthog.com',
      loaded: (ph) => {
        ph.identify();
      }
    });
  }, []);

  useEffect(() => {
    function handleResize() {
      const windowWidth = $(window).width();
      if (windowWidth < 1010) {
        $('body').addClass('small-device');
      } else {
        $('body').removeClass('small-device');
      }
    }

    $(window).on('load resize', handleResize);

    function handleMenuToggle(event) {
      event.stopPropagation(); // prevent the click event from propagating
      console.log('menu clicked'); // check if the function is being called

      const windowWidth = $(window).width();

      if (windowWidth < 1010) {
        $('body').removeClass('open');

        if (windowWidth < 760) {
          $('#left-panel').slideToggle();
        } else {
          $('#left-panel').toggleClass('open-menu');
        }
      } else {
        $('body').toggleClass('open');
        $('#left-panel').removeClass('open-menu');
      }
    }

    $(document).ready(() => {
      $('#menuToggle').on('mousedown', handleMenuToggle);

      $('.menu-item-has-children.dropdown').each(function () {
        $(this).on('mousedown', function () {
          const tempText = $(this).children('.dropdown-toggle').html();
          $(this).children('.sub-menu').prepend(`<li class="subtitle">${tempText}</li>`);
        });
      });
    });

    return () => {
      $(window).off('load resize', handleResize);
      $('#menuToggle').off('mousedown', handleMenuToggle);
      $('.menu-item-has-children.dropdown').off('mousedown');
    };
  }, []);
  return (
    <Router>
      <Suspense fallback={<PageFallback />}>
        <Switch>
          <Route path="/" component={LandingPage} exact />
          <Route path="/free50" component={Free50Signup} exact />
          <Redirect from="/free-resources" to="/free" exact />
          <Route path="/free" component={FreeResources} exact />
          <Route path="/learn-quranic-arabic" component={LearnQuranicArabic} />
          <Route path="/understand-quran-easily" component={UnderstandQuranEasily} />
          <Route path="/quran-habit-builder" component={QuranHabitBuilder} />
          <Route path="/quran-stories-for-learning" component={QuranStoriesForLearning} />
          <Route path="/best-quran-learning-app" component={BestQuranLearningApp} />
          <Route path="/blog" component={BlogList} exact />
          <Route path="/blog/10-common-quranic-words" component={CommonQuranicWords} />
          <Route path="/blog/understand-quran-without-arabic" component={UnderstandQuranWithoutArabic} />
          <Route path="/blog/daily-quran-reading-habit" component={DailyQuranHabit} />
          <Route path="/blog/beginner-guide-quranic-arabic" component={BeginnerGuideQuranicArabic} />
          <Route path="/blog/learn-read-quran-beginners" component={LearnReadQuranBeginners} />
          <Route path="/blog/memorize-quran-faster-tips" component={MemorizeQuranFasterTips} />
          <Route path="/blog/learn-arabic-for-quran" component={LearnArabicForQuran} />
          <Route path="/blog/most-common-words-quran" component={MostCommonWordsQuran} />
          <Route path="/blog/best-quran-apps-learning" component={BestQuranAppsLearning} />
          <Route path="/blog/quran-for-beginners-first-steps" component={QuranForBeginnersFirstSteps} />
          <Route path="/blog/how-long-learn-quranic-arabic" component={HowLongLearnQuranicArabic} />
          <Route path="/blog/word-by-word-quran-understand" component={WordByWordQuranUnderstand} />
          <Route path="/blog/complete-quran-ramadan-schedule-tips" component={CompleteQuranRamadanScheduleTips} />
          <Route path="/blog/learn-quran-during-ramadan" component={LearnQuranDuringRamadan} />
          <Route path="/blog/how-much-quran-read-ramadan" component={HowMuchQuranReadRamadan} />
          <Route path="/blog/quran-habit-after-ramadan" component={QuranHabitAfterRamadan} />
          <Route path="/blog/best-quran-app-ramadan" component={BestQuranAppRamadan} />
          <Route path="/blog/prepare-ramadan-quran-habit" component={PrepareRamadanQuranHabit} />
          <Route path="/blog/best-way-memorize-quran" component={BestWayMemorizeQuran} />
          <Route path="/blog/quran-memorization-techniques" component={QuranMemorizationTechniques} />
          <Route path="/blog/how-to-become-hafiz" component={HowToBecomeHafiz} />
          <Route path="/blog/best-quran-memorization-app" component={BestQuranMemorizationApp} />
          <Route path="/blog/spaced-repetition-quran-memorization" component={SpacedRepetitionQuranMemorization} />
          <Route path="/blog/memorize-quran-beginners" component={MemorizeQuranBeginners} />
          <Route path="/blog/how-long-memorize-quran" component={HowLongMemorizeQuran} />
        </Switch>
      </Suspense>
    </Router>
  );
}

export default App;
